import React from 'react';
import styles from './UIGamePlayerInfoSectionContent.module.scss';
import { UIGamePlayerInfoSectionImageWithCount } from '../../UIGamePlayerInfoSectionImageWithCount/UIGamePlayerInfoSectionImageWithCount.tsx';
import { ROAD_IMAGE_PATH, SETTLEMENT_IMAGE_PATH, CITY_IMAGE_PATH, SHIP_IMAGE_PATH, CITY_WALL_IMAGE_PATH } from '../../../../../utils/gamePieces.ts';
import { Tooltip, T } from '@colonist/ui';
export const UIGamePlayerInfoSectionContentPieces = ({ playerColor, roadCount, settlementCount, cityCount, shipCount, cityWallCount })=>{
    const roadIcon = ROAD_IMAGE_PATH[playerColor];
    const settlementIcon = SETTLEMENT_IMAGE_PATH[playerColor];
    const cityIcon = CITY_IMAGE_PATH[playerColor];
    const shipIcon = SHIP_IMAGE_PATH[playerColor];
    const cityWallIcon = CITY_WALL_IMAGE_PATH[playerColor];
    return /*#__PURE__*/ React.createElement("div", {
        className: styles.container
    }, roadCount !== undefined && /*#__PURE__*/ React.createElement(Tooltip, {
        title: /*#__PURE__*/ React.createElement(T, {
            id: "strings:game.PieceTypes.Road"
        })
    }, /*#__PURE__*/ React.createElement(UIGamePlayerInfoSectionImageWithCount, {
        piece: roadIcon,
        count: roadCount,
        size: "sm"
    })), settlementCount !== undefined && /*#__PURE__*/ React.createElement(Tooltip, {
        title: /*#__PURE__*/ React.createElement(T, {
            id: "strings:game.PieceTypes.Settlement"
        })
    }, /*#__PURE__*/ React.createElement(UIGamePlayerInfoSectionImageWithCount, {
        piece: settlementIcon,
        count: settlementCount,
        size: "sm"
    })), cityCount !== undefined && /*#__PURE__*/ React.createElement(Tooltip, {
        title: /*#__PURE__*/ React.createElement(T, {
            id: "strings:game.PieceTypes.City"
        })
    }, /*#__PURE__*/ React.createElement(UIGamePlayerInfoSectionImageWithCount, {
        piece: cityIcon,
        count: cityCount,
        size: "sm"
    })), shipCount !== undefined && /*#__PURE__*/ React.createElement(Tooltip, {
        title: /*#__PURE__*/ React.createElement(T, {
            id: "strings:game.PieceTypes.Ship"
        })
    }, /*#__PURE__*/ React.createElement(UIGamePlayerInfoSectionImageWithCount, {
        piece: shipIcon,
        count: shipCount,
        size: "sm"
    })), cityWallCount !== undefined && /*#__PURE__*/ React.createElement(Tooltip, {
        title: /*#__PURE__*/ React.createElement(T, {
            id: "strings:game.PieceTypes.CityWall"
        })
    }, /*#__PURE__*/ React.createElement(UIGamePlayerInfoSectionImageWithCount, {
        piece: cityWallIcon,
        count: cityWallCount,
        size: "sm"
    })));
};
